import type { ErrorsCode } from './ErrorsCode'

export class DomainError extends AggregateError {
  static create(errors: Error[], name?: string) {
    return new DomainError(errors, name)
  }

  static withCodes(...codes: ErrorsCode[]) {
    return new DomainError(codes.map(code => new Error(code)))
  }

  hasCode(code: ErrorsCode) {
    return this.errors.some(error => error.message === code)
  }

  withCauses(...causes: Error[]) {
    if (causes.length !== 1 && causes.length !== this.errors.length) {
      throw new Error(
        'Number of causes must be 1 (for all errors) or equal to the number of errors'
      )
    }

    const errorsWithCauses = this.errors.map((error, index) => {
      const cause = causes.length === 1 ? causes[0] : causes[index]
      const errorWithCause = new Error(error.message, { cause })
      return errorWithCause
    })

    return new DomainError(errorsWithCauses)
  }

  get message() {
    const formattedErrors = this.errors.map(error => {
      let errorSection = `Error: ${error.message}`

      if (error.cause) {
        errorSection += '\n==='
        if (error.cause instanceof Error) {
          errorSection += `\nCause: ${error.cause.message}`
        } else if (typeof error.cause === 'object' && error.cause !== null) {
          errorSection += `\nCause: ${JSON.stringify(error.cause, null, 2)}`
        } else {
          errorSection += `\nCause: ${error.cause}`
        }
      }

      return errorSection
    })

    return `DomainError\n---\n${formattedErrors.join('\n---\n')}\n---`
  }

  toJSON() {
    return { error: true, errors: this.errors.map(error => error.message), name: this.message }
  }
}
